import { render, staticRenderFns } from "./OrderItemMenuUserPromoList.vue?vue&type=template&id=0bf6a371&scoped=true&"
import script from "./OrderItemMenuUserPromoList.vue?vue&type=script&lang=js&"
export * from "./OrderItemMenuUserPromoList.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemMenuUserPromoList.vue?vue&type=style&index=0&id=0bf6a371&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf6a371",
  null
  
)

export default component.exports